export default class RepositionElement {

	/**
	 * @param {HTMLElement} element
	 */
	constructor(element) {
		const originalParent = element.parentElement;
		const mobileParent = document.querySelector(element.dataset.mobileParent);
		const breakpoint = window.matchMedia('(max-width: 768px)');
		if (!mobileParent) {
			return;
		}
		const place = () => {
			(breakpoint.matches ? mobileParent : originalParent).appendChild(element);
		}
		place();
		breakpoint.addEventListener('change', place);
	}

}
